import PropTypes from "prop-types";
import React from "react";

// Untitled UI "layers-three-01" — the design system's Series glyph. stroke is
// currentColor so it follows text color in menus/empty states; in the main nav
// the .main-menu-inline-icon CSS rule overrides stroke for hover/active states.
const SeriesNavIcon = ({ className = "main-menu-inline-icon", size = 17, style }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    style={{ marginTop: "-3px", minWidth: `${size}px`, ...style }}
    aria-hidden="true"
  >
    <path
      d="M2 17L11.6422 21.8211C11.7734 21.8867 11.839 21.9195 11.9078 21.9324C11.9687 21.9438 12.0313 21.9438 12.0922 21.9324C12.161 21.9195 12.2266 21.8867 12.3578 21.8211L22 17M2 12L11.6422 16.8211C11.7734 16.8867 11.839 16.9195 11.9078 16.9324C11.9687 16.9438 12.0313 16.9438 12.0922 16.9324C12.161 16.9195 12.2266 16.8867 12.3578 16.8211L22 12M2 7L11.6422 2.17889C11.7734 2.1133 11.839 2.0805 11.9078 2.06761C11.9687 2.0562 12.0313 2.0562 12.0922 2.06761C12.161 2.0805 12.2266 2.1133 12.3578 2.17889L22 7L12.3578 11.8211C12.2266 11.8867 12.161 11.9195 12.0922 11.9324C12.0313 11.9438 11.9687 11.9438 11.9078 11.9324C11.839 11.9195 11.7734 11.8867 11.6422 11.8211L2 7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SeriesNavIcon.propTypes = { className: PropTypes.string, size: PropTypes.number, style: PropTypes.object };

export default SeriesNavIcon;
